document.addEventListener('DOMContentLoaded', function() {
  let prodVariant = false;
  let contentFound = false;
  const grandlinkElement = document.querySelector('.grandlink');
  const contentDisplays = document.querySelectorAll('.product-popup-modal__content-info');

  if (!grandlinkElement) {
    for (const collection of collectionsData) {
      if (collection.sizechartGid !== 'none') {
        const pageId = collection.sizechartGid.split('/').pop();
        fetchPageContent(pageId, contentDisplays);
        contentFound = true;
        //console.log('collection: ',collection);
        //console.log('collection Name: ',collection.title);
        const customcollBreadcrumb = `collectionBreadcrumb_${collection.handle}`;
        //console.log('customcollBreadcrumb: ',customcollBreadcrumb);
        const collectionBreadcrumb = localStorage.getItem(customcollBreadcrumb);
        const prodBreadCrumb = document.querySelector('#product-breadcrumbs .product-breadcrumb');
       // console.log('collectionBreadcrumb: ',collectionBreadcrumb);
        if(collectionBreadcrumb){
            const parser = new DOMParser();
            const breadcrumbDoc = parser.parseFromString(collectionBreadcrumb, 'text/html');
            const breadcrumbNodes = breadcrumbDoc.body.childNodes;
            breadcrumbNodes.forEach(node => prodBreadCrumb.appendChild(node.cloneNode(true)));
        } else{
            const customBreadcrumb = document.createElement('a');
            customBreadcrumb.href = collection.url;
            customBreadcrumb.textContent = collection.title;
            customBreadcrumb.classList.add("grandlink");
    
            const delimiter = document.createElement('span');
            delimiter.className = "breadcrumb-delimeter";
            delimiter.setAttribute('aria-hidden', 'true');
            delimiter.textContent = " / ";
    
            prodBreadCrumb.appendChild(customBreadcrumb);
            prodBreadCrumb.appendChild(delimiter);
        }
        break;
      }
      else{
        contentFound = false;
      }
    }
  } else {
    const grandlink = grandlinkElement.innerText.trim();

    collectionsData.forEach((collection) => {
      if (collection.title.toLowerCase() === grandlink.toLowerCase() && collection.sizechartGid !== 'none') {
        const pageId = collection.sizechartGid.split('/').pop();
        fetchPageContent(pageId, contentDisplays);
        contentFound = true;
      }
    });

  }
  if (!contentFound) {
     const pageGuide = document.querySelectorAll('.product-popup-modal__opener');
     pageGuide.forEach(element => {
         element.style.display = 'none';
     });
  }
  function fetchPageContent(pageId, contentDisplays) {
    fetch(`https://${Shopify.shop}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'e37d6f5fced72df1026762e8fcf43b21'
      },
      body: JSON.stringify({
      query: `
        query {
          page(id: "gid://shopify/Page/${pageId}") {
            title
            handle
            body
          }
        }
      `
      })
    })
    .then(response => response.json())
    .then(data => {
      const pageContent = data.data.page.body;
      if (pageContent) {
        contentDisplays.forEach(contentDisplay => {
          contentDisplay.innerHTML = pageContent;
        });
      } else {
        contentDisplays.forEach(contentDisplay => {
          contentDisplay.innerHTML = 'Page content not available.';
        });
      }
    })
    .catch(error => {
      console.error('Error fetching page content:', error);
      contentDisplays.forEach(contentDisplay => {
        contentDisplay.innerHTML = 'Failed to load page content.';
      });
    });
  }
});